<template>
  <div class="user-order">
    <el-table fit height="496" :data="list" header-cell-class-name="table-header-cell">
      <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
        <template slot-scope="scope">
          <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户昵称" prop="nickName" min-width="120">
        <template slot-scope="{row}">{{ row.nickName | filterMemberName }}</template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile" min-width="120" />
      <el-table-column label="分享码" prop="shareCode" min-width="80" />
      <el-table-column label="身份等级" prop="gradeName" align="center" width="100" />
      <el-table-column label="消费等级" prop="consumerName" align="center" width="100" />
      <el-table-column label="合伙人身份" align="center" width="100">
        <template slot-scope="{row}">{{ row.partnership | filterPartnership }}</template>
      </el-table-column>
      <el-table-column label="注册时间" prop="createTime" min-width="150" />
    </el-table>

    <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" layout="total, sizes, prev, pager, next" @pagination="fetchData" />
  </div>
</template>

<script>
import { getMemberList } from '@/api/member'
import Pagination from '@/components/Pagination'

export default {
  name: 'UserFriend',
  components: { Pagination },
  filters: {
    filterMemberName: (memberName) => {
      return memberName || '慧生活用户'
    },
    filterPartnership: (level) => {
      return level === 3 ? '合作商' : (level === 4 ? '联盟企业' : '')
    }
  },
  props: {
    memberId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {
        inviterId: '',
        page: 1,
        limit: 10
      }
    }
  },
  mounted() {
    this.queryParams = Object.assign({}, this.queryParams, {
      inviterId: this.memberId
    })
    this.fetchData()
  },
  methods: {
    fetchData() {
      getMemberList(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.user-order {
  ::v-deep {
    .pagination-container {
      margin-top: 20px;
      padding: 0 10px 20px;
    }
  }
}
</style>
